import { render, staticRenderFns } from "./query-pay.vue?vue&type=template&id=4fd523f0&scoped=true"
import script from "./query-pay.vue?vue&type=script&lang=js"
export * from "./query-pay.vue?vue&type=script&lang=js"
import style0 from "./query-pay.vue?vue&type=style&index=0&id=4fd523f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd523f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fd523f0')) {
      api.createRecord('4fd523f0', component.options)
    } else {
      api.reload('4fd523f0', component.options)
    }
    module.hot.accept("./query-pay.vue?vue&type=template&id=4fd523f0&scoped=true", function () {
      api.rerender('4fd523f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/customer-service/query-pay.vue"
export default component.exports